var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "github-logo"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "github-fill",
    fill: "#CC0000",
    cx: 16,
    cy: 17,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0.39511 C7.1646,0.39511 0,7.55812 0,16.39511 C0,23.46406 4.58449,29.46155 10.94178,31.5772 C11.74141,31.72531 12.03497,31.23011 12.03497,30.80751 C12.03497,30.42624 12.02017,29.16559 12.01327,27.82864 C7.56205,28.79651 6.62279,25.94085 6.62279,25.94085 C5.89497,24.09174 4.84628,23.59972 4.84628,23.59972 C3.3946,22.60668 4.95571,22.62708 4.95571,22.62708 C6.56238,22.73995 7.40838,24.27615 7.40838,24.27615 C8.83542,26.72193 11.15137,26.01477 12.0644,25.60595 C12.20827,24.5721 12.62266,23.866 13.08023,23.46645 C9.52642,23.06213 5.79057,21.68994 5.79057,15.55918 C5.79057,13.81261 6.4156,12.38504 7.43911,11.26455 C7.27299,10.86156 6.72533,9.23422 7.59438,7.03034 C7.59438,7.03034 8.93795,6.60058 11.99525,8.67066 C13.27153,8.31615 14.64028,8.13837 16.00002,8.13201 C17.35976,8.13801 18.72957,8.31615 20.00823,8.67066 C23.06209,6.60058 24.40381,7.03034 24.40381,7.03034 C25.27471,9.23422 24.72705,10.86156 24.56093,11.26455 C25.58683,12.38504 26.20735,13.81261 26.20735,15.55918 C26.20735,21.70477 22.46435,23.05763 18.90152,23.45373 C19.47541,23.95025 19.98677,24.92396 19.98677,26.4167 C19.98677,28.55753 19.96847,30.28052 19.96847,30.80751 C19.96847,31.23355 20.25621,31.7322 21.06723,31.57534 C27.42134,29.45731 32,23.46194 32,16.39511 C32,7.55812 24.83646,0.39511 16,0.39511",
    id: "path28",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06011,23.36741 C6.02491,23.44721 5.89981,23.47101 5.78588,23.41641 C5.66957,23.36391 5.60466,23.25558 5.64228,23.17583 C5.67668,23.09423 5.80178,23.07144 5.91783,23.12603 C6.03388,23.17823 6.10012,23.28765 6.06011,23.3674",
    id: "path32",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70828,24.09034 C6.63198,24.16104 6.48254,24.12824 6.38159,24.01644 C6.27667,23.90489 6.25733,23.75546 6.33469,23.68392 C6.41339,23.61322 6.55804,23.64632 6.6627,23.75782 C6.76762,23.87069 6.78802,24.01854 6.7083,24.09034",
    id: "path36",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3391,25.01171 C7.2411,25.08011 7.08051,25.01571 6.98141,24.87393 C6.88341,24.73139 6.88341,24.56076 6.98341,24.4924 C7.08251,24.424 7.24068,24.4854 7.34109,24.62673 C7.43889,24.7714 7.43889,24.94203 7.33909,25.01171",
    id: "path40",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2033,25.90206 C8.1156,25.99876 7.92881,25.97276 7.79209,25.84056 C7.6522,25.71179 7.61325,25.52871 7.70099,25.432 C7.78999,25.335 7.97786,25.3623 8.11564,25.4932 C8.25448,25.62196 8.2966,25.80637 8.20334,25.90202",
    id: "path44",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39559,26.41901 C9.35669,26.54433 9.177,26.60103 8.99578,26.54778 C8.81481,26.49298 8.69638,26.34641 8.73294,26.21977 C8.77054,26.09365 8.95126,26.0343 9.13382,26.09126 C9.31451,26.14586 9.43321,26.29157 9.39559,26.41901",
    id: "path48",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.70509,26.51476 C10.71009,26.64671 10.55592,26.75613 10.36568,26.75852 C10.17439,26.76252 10.01939,26.65598 10.01727,26.52615 C10.01727,26.39288 10.16776,26.28478 10.3588,26.28134 C10.54903,26.27734 10.70509,26.38387 10.70509,26.51476",
    id: "path52",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9235,26.3075 C11.9463,26.436 11.81407,26.56821 11.62516,26.60345 C11.43943,26.63765 11.26748,26.55785 11.24389,26.43044 C11.22089,26.29849 11.35518,26.16628 11.54091,26.1321 C11.73008,26.0993 11.89939,26.1766 11.9235,26.3075",
    id: "path56",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github_logo.e453ec0e7200639756a8972d12079c9c.svg";
export { ForwardRef as ReactComponent };